import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import envConfig from "../../config";
import BackdropLoading from "../../components/BackdropLoading/BackdropLoading";

const BankFeedsConnected = () => {
  const location = useLocation();
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (hasRedirected.current) return;

    const queryParams = new URLSearchParams(location.search);
    const state = queryParams.get("state");
    const jobId =
      queryParams.get("jobId") ||
      (queryParams.get("jobIds") || "").split(",")[0]?.trim() ||
      "";

    // Redirect to state page first; the state page will call register-async so errors are visible
    const baseUrl = window.location.origin;
    const targetUrl =
      state && (state.startsWith("http://") || state.startsWith("https://"))
        ? state
        : `${baseUrl}/user-dashboard`;
    const target = new URL(targetUrl);
    if (jobId) target.searchParams.set("jobId", jobId);
    hasRedirected.current = true;
    window.location = target.toString();
  }, [location.search]);

  return <BackdropLoading open={true} />;
};

export default BankFeedsConnected;
